import dayjs from "dayjs";
import { isEmpty } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";

const TimeLogs = ({ timeLogData }) => {
  const { t } = useTranslation();

  return (
    <>
      {timeLogData &&
        timeLogData?.map((item, i) => {
          return (
            <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
              <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                {i + 1}
              </th>
              <td className="py-4 px-6 border-r text-gray-900">{item?.createdAt ? dayjs(item?.createdAt).format("MM-DD-YYYY") : "N/A"}</td>
              <td className="py-4 px-6 border-r text-gray-900">{item?.startTime ? dayjs(item?.startTime).format("h:mm A") : "N/A"}</td>
              <td className="py-4 px-6 border-r text-gray-900">{item?.endTime ? dayjs(item?.endTime).format("h:mm A") : "N/A"}</td>
            </tr>
          );
        })}
      {isEmpty(timeLogData) ? (
        <tr className="bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700">
          <td className="py-4 px-6 border-r" colSpan={5}>
            {t("O_NO_RECORD_FOUND")}
          </td>
        </tr>
      ) : null}
    </>
  );
};

export default TimeLogs;
